/* Native search: search-as-you-type for every header search box, using Shopify's
   predictive search (replaces Boost's instant search and the theme's older dropdown).
   Shows in-stock products (with price) and matching collections from the second letter. */
(function () {
  'use strict';
  var money = function (v) {
    var n = parseFloat(v);
    return isNaN(n) ? '' : '£' + n.toFixed(2);
  };
  var esc = function (t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var img = function (src) {
    if (!src) return '';
    return src.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2');
  };

  // Boost's "Popular searches" list, shown when nothing matches
  var POPULAR = ['trucks', 'grip tape', 'toy machine', 'girl', 'sunset', 'santa cruz', 'creature', 'chocolate', 'bearings', 'baker'];
  function popularHtml() {
    return '<div class="np-head">Popular searches</div><ul class="np-cols">' + POPULAR.map(function (t) {
      return '<li><a href="/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(t) + '">' + esc(t) + '</a></li>';
    }).join('') + '</ul>';
  }


  /* ---------- an exact brand name goes straight to that brand's page ---------- */
  // Brand collections are titled "BRAND | <name>". Generic-word brands are left out so a
  // search for "cream" or "real" still searches. Add "&nr=1" to a search URL to skip this.
  var NOT_A_BRAND_SEARCH = ['there', 'real', 'cream', 'rage', 'verb', 'death', 'radical', 'deluxe', 'viper', 'thank you'];
  var BRAND_NOISE = /\b(skateboards?|scooters?|trucks?|wheels?|bearings|eyewear|footwear|rollerskates|magazine|grip tape|longboards|skate co|supply co|surf skates.*)\b/g;
  function norm(t) { return String(t).toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function brandUrl(q, collections) {
    var nq = norm(q);
    if (!nq || NOT_A_BRAND_SEARCH.indexOf(nq) !== -1) return null;
    var hit = null;
    (collections || []).forEach(function (c) {
      var m = /^\s*brands?\s*\|\s*(.+)$/i.exec(c.title || '');
      if (!m || hit) return;
      var full = norm(m[1]), short = norm(m[1].toLowerCase().replace(BRAND_NOISE, ''));
      if (nq === full || nq === short || (short.indexOf(nq + ' ') === 0 && nq.length >= 5)) hit = c.url;
    });
    return hit;
  }
  // Exact category searches go to that category, which has the right filters (Baymard).
  var CATEGORY = {
    '/collections/skateboard-decks': ['deck', 'decks', 'skateboard deck', 'skateboard decks', 'skate deck', 'skate decks'],
    '/collections/skateboard-trucks': ['trucks', 'skateboard trucks', 'skate trucks'],
    '/collections/skateboard-wheels': ['wheels', 'skateboard wheels', 'skate wheels'],
    '/collections/skateboard-bearings': ['bearings', 'skateboard bearings'],
    '/collections/skateboard-helmets': ['helmet', 'helmets', 'skate helmet', 'skate helmets', 'skateboard helmet', 'skateboard helmets'],
    '/collections/skateboard-pad-sets-protection-knee-pads': ['knee pads', 'kneepads'],
    '/collections/complete-skateboards-the-fastest-way-to-start-skateboarding': ['complete', 'completes', 'complete skateboard', 'complete skateboards', 'skateboard complete', 'skateboard completes'],
    '/collections/stunt-scooters': ['scooter', 'scooters', 'stunt scooter', 'stunt scooters', 'complete scooter', 'complete scooters'],
    '/collections/quad-roller-skates': ['roller skates', 'roller skate', 'quad skates', 'quads', 'quad roller skates', 'rollerskates'],
    '/collections/inline-skates': ['inline skates', 'inlines', 'rollerblades', 'roller blades'],
    '/collections/longboards': ['longboard', 'longboards', 'long board', 'long boards'],
    '/collections/longboard-cruiser-completes': ['cruiser', 'cruisers', 'cruiser board', 'cruiser boards'],
    '/collections/all-surf-skates': ['surfskate', 'surfskates', 'surf skate', 'surf skates'],
    '/collections/clothing-shoes': ['shoes', 'skate shoes', 'trainers'],
    '/collections/clothing-hoodies-crews': ['hoodie', 'hoodies', 'hoody', 'hoodys'],
    '/collections/clothing-t-shirts': ['t shirt', 't shirts', 'tshirt', 'tshirts', 'tee', 'tees'],
    '/collections/clothing-socks': ['socks'],
    '/collections/clothing': ['clothing', 'clothes'],
    '/collections/skateboard-truck-hardware-bushings': ['bushings', 'bushing'],
    '/collections/skateboard-parts-hardware-skate-tools': ['skate tool', 'skate tools', 'skateboard tool', 'skateboard tools', 'tool', 'tools'],
    '/collections/skateboard-grip-tape-for-decks': ['grip tape', 'griptape', 'grip', 'skateboard grip tape', 'skateboard grip', 'grip tape for skateboard'],
    '/collections/skateboard-hardware-bolts-tools-grip-tape-risers-bushings-kingpins': ['hardware', 'skateboard hardware', 'bolts', 'skateboard bolts', 'truck bolts', 'kingpins', 'kingpin', 'repair kit', 'skateboard repair kit'],
    '/collections/skateboard-riser-pads': ['risers', 'riser pads', 'riser', 'shock pads'],
    '/collections/skateboard-stickers': ['stickers', 'sticker', 'skate stickers', 'skateboard stickers'],
    '/collections/skateboard-curb-wax': ['wax', 'skate wax', 'curb wax'],
    '/collections/skateboard-deck-rails': ['rails', 'deck rails', 'skateboard rails'],
    '/collections/blank-skateboard-decks': ['blank decks', 'blank deck', 'blank skateboard'],
    '/collections/old-skool-skateboards': ['old skool', 'old school', 'old skool skateboards', 'old school skateboards', 'old skool decks', 'old school decks', 'retro skateboards'],
    '/collections/junior-mini-youth-complete-skateboards-for-kids': ['kids skateboard', 'kids skateboards', 'junior skateboard', 'junior skateboards', 'mini skateboard', 'mini skateboards', 'childrens skateboard', 'kids complete',
      'toddler skateboard', 'toddler skateboards', 'kids complete skateboard', 'kids complete skateboards', 'kids complete skateboard set', 'kids skateboard set', 'junior skate', 'junior complete', 'junior completes', 'child skateboard', 'childrens skateboards'],
    '/collections/complete-skateboards-for-beginners-kids': ['beginner skateboard', 'beginner skateboards', 'beginners skateboard', 'starter skateboard',
      'beginners skateboards', 'skateboard for beginners', 'skateboards for beginners', 'skateboard for beginner', 'skateboards for beginner', 'beginner complete', 'beginner completes'],
    '/collections/kids-junior-skateboard-bundle-packs': ['skateboard bundle', 'skateboard bundles', 'starter bundle', 'skateboard and helmet', 'skateboard helmet and pads'],
    '/collections/electric-skateboards-fast-powered-skateboards-longboards': ['electric skateboard', 'electric skateboards', 'electric longboard', 'e skateboard'],
    '/collections/tech-deck-finger-boards-hand-boards-scooters-bikes': ['tech deck', 'tech decks', 'fingerboard', 'fingerboards', 'finger board', 'finger boards'],
    '/collections/skateboard-accessories': ['skateboard accessories', 'skate accessories', 'accessories'],
    '/collections/skateboard-parts': ['skateboard parts', 'skate parts', 'parts'],
    '/collections/skateboard-pad-sets-protection-elbow-pads': ['elbow pads', 'elbow pad'],
    '/collections/skateboard-pad-sets-protection-wrist-guards': ['wrist guards', 'wrist guard', 'wrist pads'],
    '/collections/protection-pad-sets-skateboarding-roller-skates': ['pads', 'pad set', 'pad sets', 'pad pack', 'knee and elbow pads', 'protective pads'],
    '/collections/skateboard-protection-pads-helmets': ['protection', 'protective gear', 'safety gear', 'helmet and pads', 'pads and helmet'],
    '/collections/protection-helmet-liners': ['helmet liner', 'helmet liners', 'helmet pads'],
    '/collections/protection-insoles': ['insoles', 'insole'],
    '/collections/clothing-beanies': ['beanie', 'beanies', 'woolly hat'],
    '/collections/clothing-hats-caps-beanies': ['hats', 'hat', 'caps', 'cap', 'hats and caps'],
    '/collections/clothing-jackets': ['jacket', 'jackets', 'coat', 'coats'],
    '/collections/clothing-jeans-trousers': ['jeans', 'trousers', 'pants', 'chinos'],
    '/collections/clothing-shorts-board-shorts': ['shorts', 'jorts', 'board shorts', 'boardshorts'],
    '/collections/clothing-long-sleeve-t-shirts': ['long sleeve', 'long sleeve t shirt', 'long sleeve t shirts', 'long sleeve tee', 'long sleeves'],
    '/collections/clothing-accessories-sunglasses': ['sunglasses', 'sunnies', 'shades', 'glasses'],
    '/collections/accessories-bags-rucksacks-backpacks': ['bag', 'bags', 'backpack', 'backpacks', 'rucksack', 'rucksacks'],
    '/collections/kids-skateboard-clothing': ['kids clothing', 'kids clothes', 'childrens clothing'],
    '/collections/womens-skateboard-clothing': ['womens clothing', 'womens', 'ladies clothing', 'girls clothing'],
    '/collections/mens-skateboard-clothing': ['mens clothing', 'mens'],
    '/collections/shoes-sliders-flip-flops': ['sliders', 'slides', 'flip flops', 'sandals'],
    '/collections/scooter-wheels': ['scooter wheels', 'scooter wheel'],
    '/collections/scooters-handle-bars': ['scooter bars', 'scooter bar', 'handlebars', 'handle bars', 'scooter handlebars'],
    '/collections/scooters-handle-bar-grips': ['scooter grips', 'grips', 'handlebar grips', 'bar grips'],
    '/collections/scooters-scooter-forks': ['scooter forks', 'scooter fork', 'forks'],
    '/collections/scooters-scooter-decks': ['scooter decks', 'scooter deck'],
    '/collections/scooter-grip-tape': ['scooter grip tape', 'scooter grip'],
    '/collections/scooter-hardware': ['scooter hardware', 'scooter clamps', 'scooter clamp', 'clamps', 'headset', 'headsets', 'compression'],
    '/collections/scooter-parts-hardware': ['scooter parts', 'scooter accessories'],
    '/collections/scooters-for-kids-juniors': ['kids scooter', 'kids scooters', 'junior scooter', 'junior scooters', 'childrens scooter'],
    '/collections/skates': ['skates', 'skating'],
    '/collections/aggressive-inline-skates': ['aggressive skates', 'aggressive inline skates', 'aggressive inlines'],
    '/collections/adjustable-kids-skates': ['kids roller skates', 'kids skates', 'adjustable skates', 'adjustable roller skates', 'childrens roller skates'],
    '/collections/skates-skate-wheels-for-quad-inline-skates': ['roller skate wheels', 'quad wheels', 'inline wheels', 'skate wheels for roller skates', 'inline skate wheels', 'quad skate wheels'],
    '/collections/skates-stoppers-brakes-for-roller-skates': ['toe stops', 'toe stop', 'toe stoppers', 'stoppers', 'brakes', 'jam plugs'],
    '/collections/roller-skate-boot-bags': ['skate bag', 'boot bag', 'roller skate bag'],
    '/collections/skate-parts-accessories': ['roller skate parts', 'roller skate accessories', 'skate parts and accessories'],
    '/collections/ice-skates': ['ice skates', 'ice skate', 'ice skating'],
    '/collections/all-wheeled-shoes-heelys-breezy-rollers': ['heelys', 'heely', 'wheeled shoes', 'wheelie shoes', 'roller shoes', 'breezy rollers', 'shoes with wheels'],
    '/collections/longboard-trucks': ['longboard trucks', 'longboard truck'],
    '/collections/longboards-wheels-for-longboard-skateboards': ['longboard wheels', 'cruiser wheels', 'soft wheels'],
    '/collections/longboards-decks': ['longboard deck', 'longboard decks'],
    '/collections/surfskate-wheels': ['surfskate wheels', 'surf skate wheels'],
    '/collections/surfskate-decks': ['surfskate deck', 'surfskate decks', 'surf skate deck', 'surf skate decks'],
    '/collections/surf-skate-truck-kits': ['surfskate trucks', 'surf skate trucks', 'surfskate truck kit', 'surf skate truck kit'],
    '/collections/water-sports-surfboards': ['surfboard', 'surfboards', 'surf board', 'surf boards', 'foamie', 'foam surfboard'],
    '/collections/water-sports-bodyboards': ['bodyboard', 'bodyboards', 'body board', 'body boards', 'boogie board'],
    '/collections/water-sports-surfboard-fins': ['surf fins', 'surfboard fins', 'fins'],
    '/collections/water-sports-all-surfing-bodyboards-fins-accessories-copy': ['swim fins', 'swimming fins', 'flippers'],
    '/collections/water-sports-leashes-for-surfboards-bodyboards': ['leash', 'leashes', 'surf leash'],
    '/collections/water-sports-surf-hand-planes': ['hand plane', 'hand planes', 'handplane'],
    '/collections/water-sports-skimboards': ['skimboard', 'skimboards', 'skim board'],
    '/collections/water-sports-bodyboards-fins': ['surfing', 'surf', 'water sports', 'watersports'],
    '/collections/skatewarehouse-gift-cards': ['gift card', 'gift cards', 'voucher', 'gift voucher'],
    '/collections/ramps-rails-for-skateboarding-skates-scooters': ['ramp', 'ramps', 'grind rail', 'grind box']
  };
  // "skate board" is how a lot of people type it ("toddler skate board", "8.5 skate board")
  function oneWord(t) { return t.replace(/\bskate (board|boards)\b/g, 'skate$1'); }
  // "age 13 skateboard", "6 year old skateboard": up to 7 is a junior board, older starts on a beginner complete
  function ageUrl(nq) {
    if (!/\b(skateboards?|complete|completes|board)\b/.test(nq)) return null;
    var m = /\bage[ds]? (\d{1,2})\b|\b(\d{1,2}) ?(?:year|yr)s? old\b|\b(\d{1,2}) ?yo\b/.exec(nq);
    if (!m) return null;
    var age = +(m[1] || m[2] || m[3]);
    if (!age || age > 17) return null;
    return age <= 7 ? '/collections/junior-mini-youth-complete-skateboards-for-kids' : '/collections/complete-skateboards-for-beginners-kids';
  }
  function categoryUrl(q) {
    var nq = oneWord(norm(q)), hit = ageUrl(nq);
    if (hit) return hit;
    [nq, nq.replace(/s$/, ''), nq + 's'].forEach(function (t) {   // exact first, then singular / plural
      Object.keys(CATEGORY).forEach(function (url) { if (!hit && CATEGORY[url].indexOf(t) !== -1) hit = url; });
    });
    return hit;
  }

  /* ---------- Santa Cruz x Pokémon: ~1,000 searches a week (late Oct 2026), but the decks are sold out
     between drops, so the in-stock results showed hoodies instead. Any Pokémon search goes to the
     collection page, which carries the next drop and the reminder sign-up. norm() turns "é" into a
     space, so "pokémon" arrives as "pok mon". "poke" alone is a real product (Poke Deck): the drop-down
     offers the shortcut for it, but Enter still searches. */
  var POKEMON_URL = '/collections/santa-cruz-x-pokemon-limited-edition-decks';
  var POKEMON_DROP = { label: 'Drop 2: Fri 30 Oct, 4:15pm', until: Date.parse('2026-10-30T16:15:00Z') };
  var POKEMON_WORD = /\b(pok ?e? ?m[oa][nm]?[es]?|pikachu)\b/;
  function pokemonUrl(q) { return POKEMON_WORD.test(norm(q)) ? POKEMON_URL : null; }
  function pokemonHint(q) {
    var nq = norm(q);
    if (!POKEMON_WORD.test(nq) && !/^(pok|poke|pokem)$/.test(nq)) return null;
    return Date.now() < POKEMON_DROP.until ? POKEMON_DROP.label + ', get a reminder' : 'See the range';
  }

  /* ---------- understand the query: a category word plus brand / size / colour words
     -> that category, already filtered ("santa cruz 8.25 deck", "54mm wheels", "black hoodie").
     The values come from the collection's own filter list (templates/collection.native-filters.liquid),
     so the link is exact, and it is only offered when that filtered page has products in stock. */
  var CATEGORY_NAME = {
    '/collections/skateboard-decks': 'Skateboard Decks', '/collections/skateboard-trucks': 'Skateboard Trucks',
    '/collections/skateboard-wheels': 'Skateboard Wheels', '/collections/skateboard-bearings': 'Skateboard Bearings',
    '/collections/skateboard-helmets': 'Helmets', '/collections/skateboard-pad-sets-protection-knee-pads': 'Knee Pads',
    '/collections/complete-skateboards-the-fastest-way-to-start-skateboarding': 'Complete Skateboards',
    '/collections/stunt-scooters': 'Stunt Scooters', '/collections/quad-roller-skates': 'Roller Skates',
    '/collections/inline-skates': 'Inline Skates', '/collections/longboards': 'Longboards',
    '/collections/longboard-cruiser-completes': 'Cruisers', '/collections/all-surf-skates': 'Surf Skates',
    '/collections/clothing-shoes': 'Skate Shoes', '/collections/clothing-hoodies-crews': 'Hoodies',
    '/collections/clothing-t-shirts': 'T-Shirts', '/collections/clothing-socks': 'Socks', '/collections/clothing': 'Clothing',
    '/collections/skateboard-truck-hardware-bushings': 'Bushings', '/collections/skateboard-parts-hardware-skate-tools': 'Skate Tools',
    '/collections/skateboard-grip-tape-for-decks': 'Grip Tape', '/collections/skateboard-hardware-bolts-tools-grip-tape-risers-bushings-kingpins': 'Skateboard Hardware',
    '/collections/skateboard-riser-pads': 'Riser Pads', '/collections/skateboard-stickers': 'Stickers', '/collections/skateboard-curb-wax': 'Skate Wax',
    '/collections/skateboard-deck-rails': 'Deck Rails', '/collections/blank-skateboard-decks': 'Blank Decks', '/collections/old-skool-skateboards': 'Old Skool Skateboards',
    '/collections/junior-mini-youth-complete-skateboards-for-kids': 'Kids Skateboards', '/collections/complete-skateboards-for-beginners-kids': 'Beginner Skateboards',
    '/collections/kids-junior-skateboard-bundle-packs': 'Skateboard Bundles', '/collections/electric-skateboards-fast-powered-skateboards-longboards': 'Electric Skateboards',
    '/collections/tech-deck-finger-boards-hand-boards-scooters-bikes': 'Fingerboards', '/collections/skateboard-accessories': 'Skateboard Accessories',
    '/collections/skateboard-parts': 'Skateboard Parts', '/collections/skateboard-pad-sets-protection-elbow-pads': 'Elbow Pads',
    '/collections/skateboard-pad-sets-protection-wrist-guards': 'Wrist Guards', '/collections/protection-pad-sets-skateboarding-roller-skates': 'Pad Sets',
    '/collections/skateboard-protection-pads-helmets': 'Pads & Helmets', '/collections/protection-helmet-liners': 'Helmet Liners', '/collections/protection-insoles': 'Insoles',
    '/collections/clothing-beanies': 'Beanies', '/collections/clothing-hats-caps-beanies': 'Hats & Caps', '/collections/clothing-jackets': 'Jackets',
    '/collections/clothing-jeans-trousers': 'Jeans & Trousers', '/collections/clothing-shorts-board-shorts': 'Shorts', '/collections/clothing-long-sleeve-t-shirts': 'Long Sleeve T-Shirts',
    '/collections/clothing-accessories-sunglasses': 'Sunglasses', '/collections/accessories-bags-rucksacks-backpacks': 'Bags & Backpacks',
    '/collections/kids-skateboard-clothing': "Kids' Clothing", '/collections/womens-skateboard-clothing': "Women's Clothing", '/collections/mens-skateboard-clothing': "Men's Clothing",
    '/collections/shoes-sliders-flip-flops': 'Sliders & Flip Flops', '/collections/scooter-wheels': 'Scooter Wheels', '/collections/scooters-handle-bars': 'Scooter Bars',
    '/collections/scooters-handle-bar-grips': 'Scooter Grips', '/collections/scooters-scooter-forks': 'Scooter Forks', '/collections/scooters-scooter-decks': 'Scooter Decks',
    '/collections/scooter-grip-tape': 'Scooter Grip Tape', '/collections/scooter-hardware': 'Scooter Hardware', '/collections/scooter-parts-hardware': 'Scooter Parts',
    '/collections/scooters-for-kids-juniors': 'Kids Scooters', '/collections/skates': 'Skates', '/collections/aggressive-inline-skates': 'Aggressive Inline Skates',
    '/collections/adjustable-kids-skates': 'Kids Roller Skates', '/collections/skates-skate-wheels-for-quad-inline-skates': 'Roller Skate Wheels',
    '/collections/skates-stoppers-brakes-for-roller-skates': 'Toe Stops & Brakes', '/collections/roller-skate-boot-bags': 'Skate Bags',
    '/collections/skate-parts-accessories': 'Roller Skate Parts', '/collections/ice-skates': 'Ice Skates', '/collections/all-wheeled-shoes-heelys-breezy-rollers': 'Roller Shoes',
    '/collections/longboard-trucks': 'Longboard Trucks', '/collections/longboards-wheels-for-longboard-skateboards': 'Longboard & Cruiser Wheels',
    '/collections/longboards-decks': 'Longboard Decks', '/collections/surfskate-wheels': 'Surf Skate Wheels', '/collections/surfskate-decks': 'Surf Skate Decks',
    '/collections/surf-skate-truck-kits': 'Surf Skate Truck Kits', '/collections/water-sports-surfboards': 'Surfboards', '/collections/water-sports-bodyboards': 'Bodyboards',
    '/collections/water-sports-surfboard-fins': 'Surfboard Fins', '/collections/water-sports-all-surfing-bodyboards-fins-accessories-copy': 'Swim Fins',
    '/collections/water-sports-leashes-for-surfboards-bodyboards': 'Leashes', '/collections/water-sports-surf-hand-planes': 'Hand Planes',
    '/collections/water-sports-skimboards': 'Skimboards', '/collections/water-sports-bodyboards-fins': 'Surfing', '/collections/skatewarehouse-gift-cards': 'Gift Cards',
    '/collections/ramps-rails-for-skateboarding-skates-scooters': 'Ramps & Rails'
  };
  // words that change the ORDER rather than the filter
  var SORT_WORDS = { cheap: 'price-ascending', cheapest: 'price-ascending', budget: 'price-ascending', bargain: 'price-ascending',
    new: 'created-descending', newest: 'created-descending', latest: 'created-descending',
    best: 'best-selling', popular: 'best-selling', 'best selling': 'best-selling', bestselling: 'best-selling' };
  var SORT_LABEL = { 'price-ascending': 'cheapest first', 'created-descending': 'newest first', 'best-selling': 'best sellers first' };
  var STOP = ['a', 'an', 'the', 'for', 'with', 'and', 'in', 'of', 'skate', 'skateboard', 'skateboards', 'board', 'boards',
    'uk', 'buy', 'size', 'sizes', 'inch', 'inches', 'in stock', 'colour', 'color', 'some', 'any'];
  function qkey(t) {
    return String(t).toLowerCase().replace(/["″”'’]/g, '').replace(/(\d)\s*(mm|cm|a)\b/g, '$1$2')
      .replace(/(\d+)\.0+(?![\d])/g, '$1').replace(/[^a-z0-9.\s/]+/g, ' ').replace(/\s+/g, ' ').trim();
  }
  function hasPhrase(hay, ph) { return (' ' + hay + ' ').indexOf(' ' + ph + ' ') !== -1; }
  function dropPhrase(hay, ph) { return (' ' + hay + ' ').replace(' ' + ph + ' ', ' ').replace(/\s+/g, ' ').trim(); }
  function findCategory(k) {
    var best = null;
    Object.keys(CATEGORY).forEach(function (url) {
      CATEGORY[url].forEach(function (ph) {
        var pk = qkey(ph);
        if (hasPhrase(k, pk) && (!best || pk.length > best.ph.length)) best = { url: url, ph: pk };
      });
    });
    return best;
  }
  var filterCache = {};
  function getFilters(url, extra) {
    var u = url + '?view=native-filters&filter.v.availability=1' + (extra || '');
    if (!filterCache[u]) filterCache[u] = fetch(u).then(function (r) { return r.json(); }).catch(function () { return null; });
    return filterCache[u];
  }
  var SKIP_PARAM = /availability|product_type|age-range/;
  function understand(q) {
    var k = oneWord(qkey(q)), cat = findCategory(k);
    if (!cat) return Promise.resolve(null);
    var rest = dropPhrase(k, cat.ph), sort = null;
    Object.keys(SORT_WORDS).forEach(function (w) { if (hasPhrase(rest, w)) { sort = SORT_WORDS[w]; rest = dropPhrase(rest, w); } });
    return getFilters(cat.url).then(function (d) {
      if (!d) return null;
      var picks = [];   // [{param, values:[...], label}]
      d.filters.forEach(function (f) {
        if (SKIP_PARAM.test(f.param)) return;
        var isVendor = /vendor/.test(f.param), best = null;
        f.values.forEach(function (v) {
          if (!v.c) return;
          var vk = qkey(v.l);
          if (!vk || (vk.length < 2 && !/^\d+$/.test(vk))) return;
          // a brand can include the category word ("Bones Bearings"), so test it against the whole query too
          var hit = hasPhrase(rest, vk) || (isVendor && hasPhrase(k, vk));
          if (hit && (!best || vk.length > best.vk.length)) best = { vk: vk, label: v.l };
        });
        if (!best) return;
        var vals = f.values.filter(function (v) { return v.c && qkey(v.l) === best.vk; }).map(function (v) { return v.v; });
        picks.push({ param: f.param, values: vals, label: best.label });
        best.vk.split(' ').forEach(function (w) { rest = dropPhrase(rest, w); });
      });
      var left = rest.split(' ').filter(function (w) { return w && STOP.indexOf(w) === -1; });
      function qs(list) {
        var parts = [];
        list.forEach(function (p) { p.values.forEach(function (v) { parts.push(encodeURIComponent(p.param) + '=' + encodeURIComponent(v)); }); });
        if (sort) parts.push('sort_by=' + sort);
        return parts.join('&');
      }
      function result(list, n, exact) {
        var q2 = qs(list);
        return { url: cat.url + (q2 ? '?' + q2 : ''), what: list.map(function (p) { return p.label; }), where: CATEGORY_NAME[cat.url] || '',
                 count: n, sort: sort ? SORT_LABEL[sort] : '', complete: exact && left.length === 0, filtered: list.length > 0 || !!sort,
                 partial: !exact };
      }
      if (!picks.length) return (left.length && !sort) ? null : result([], d.count, true);
      var all = qs(picks.filter(function () { return true; })).replace(/(^|&)sort_by=[^&]*/, '');
      return getFilters(cat.url, '&' + all).then(function (d2) {
        if (d2 && d2.count) return result(picks, d2.count, true);
        if (picks.length < 2) return null;
        // nothing has every word: offer the single filter with the most in stock (e.g. Santa Cruz decks, any size)
        return Promise.all(picks.map(function (p) {
          return getFilters(cat.url, '&' + qs([p]).replace(/(^|&)sort_by=[^&]*/, '')).then(function (dx) { return { p: p, n: dx ? dx.count : 0 }; });
        })).then(function (rs) {
          rs.sort(function (a, b) {
            var av = /vendor/.test(a.p.param) && a.n ? 1 : 0, bv = /vendor/.test(b.p.param) && b.n ? 1 : 0;
            return (bv - av) || (b.n - a.n);
          });
          return rs[0].n ? result([rs[0].p], rs[0].n, false) : null;
        });
      });
    });
  }

  /* ---------- recent searches (this browser only) ---------- */
  var RECENT_KEY = 'np-recent';
  function recentList() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } }
  function rememberSearch(q) {
    q = String(q || '').trim(); if (q.length < 2) return;
    try {
      var l = recentList().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
      l.unshift(q); localStorage.setItem(RECENT_KEY, JSON.stringify(l.slice(0, 6)));
    } catch (e) {}
  }
  function forgetSearch(q) {
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(recentList().filter(function (x) { return x !== q; }))); } catch (e) {}
  }

  /* Any other search that names a collection ("carver wheels", "longboard hardware") goes to it:
     every word typed must be in the collection's title, with at most two other words. */
  var COLLECTION_SKIP = /black friday|deals|\bsale\b|clearance|from the game|wheelchair|boost|on demand|orderly|upsell|returns|^hide$|^brands?\s*\|/i;
  var FILLER = ['skateboard', 'skateboards', 'skateboarding', 'for', 'the', 'and', 'all', 'more', 'a', 'of', 'with', 'parts', 'ready', 'to', 'ride'];
  function words(t) {
    return norm(t).split(' ').map(function (w) { return w.length > 3 ? w.replace(/s$/, '') : w; })
      .filter(function (w) { return w && FILLER.indexOf(w) === -1; });
  }
  function collectionMatch(q, cols) {
    var qw = words(q), best = null, bestExtra = 3;
    if (!qw.length) return null;
    (cols || []).forEach(function (c) {
      if (COLLECTION_SKIP.test(c.title || '')) return;
      var tw = words(c.title);
      if (!qw.every(function (w) { return tw.indexOf(w) !== -1; })) return;
      var extra = tw.filter(function (w) { return qw.indexOf(w) === -1; }).length;
      if (extra < bestExtra) { best = c.url.split('?')[0]; bestExtra = extra; }
    });
    return best;
  }
  function lookupBrand(q) {
    var cat = categoryUrl(q);
    if (cat) return Promise.resolve(cat);
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=collection&resources[limit]=10';
    return fetch(url).then(function (r) { return r.json(); })
      .then(function (d) {
        var cols = d && d.resources && d.resources.results && d.resources.results.collections;
        return brandUrl(q, cols) || collectionMatch(q, cols);
      })
      .catch(function () { return null; });
  }
  // where a submitted search should go instead of the results page (null: stay on search)
  function destination(q) {
    var pk = pokemonUrl(q);
    if (pk) return Promise.resolve(pk);
    return understand(q).catch(function () { return null; }).then(function (sm) {
      if (sm && sm.complete && sm.filtered) return sm.url;
      return lookupBrand(q);
    });
  }

  function attach(input) {
    var form = input.closest('form');
    if (!form || form.__nativePredictive) return;
    form.__nativePredictive = true;
    // retire the theme's older dropdown on this form
    if (window.jQuery) { window.jQuery(input).off('keyup change'); window.jQuery(form).find('.search-results').remove(); }
    input.setAttribute('autocomplete', 'off');
    form.classList.add('np-form');
    var box = document.createElement('div');
    box.className = 'np-results';
    box.hidden = true;
    form.appendChild(box);
    var timer, last = '', ctrl, smartNow = null;

    function close() { box.hidden = true; document.documentElement.classList.remove('np-open'); }
    function open() { box.hidden = false; document.documentElement.classList.add('np-open'); }
    function hl(text, q) {   // bold the words the customer typed
      var t = esc(text), words = q.toLowerCase().split(/\s+/).filter(function (w) { return w.length > 1; });
      words.forEach(function (w) {
        var re = new RegExp('(' + w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
        t = t.replace(re, '<mark>$1</mark>');
      });
      return t.replace(/<mark>([^<]*)<\/mark>/g, function (m) { return m; });
    }
    function hlRest(text, q) {   // "bones" -> bones <b>wheels</b>: emphasise what the suggestion adds
      var t = String(text), lq = q.toLowerCase().trim(), i = t.toLowerCase().indexOf(lq);
      if (i === -1) return '<mark>' + esc(t) + '</mark>';
      return (i ? '<mark>' + esc(t.slice(0, i)) + '</mark>' : '') + esc(t.slice(i, i + lq.length)) + '<mark>' + esc(t.slice(i + lq.length)) + '</mark>';
    }
    function cleanCollection(title) {   // "BRAND | Santa Cruz" -> "Santa Cruz"; "Surf Skate | Wheels" -> "Surf Skate Wheels"
      var t = String(title || '');
      var m = /^\s*([^|]{1,30})\|\s*(.+)$/.exec(t);
      if (m) {
        var pre = m[1].trim(), rest = m[2].trim();
        if (/^brand$/i.test(pre)) t = rest.replace(/\s+(wheels|decks|trucks|bearings)$/i, '');
        else if (rest.split(/\s+/).length <= 2 && rest.toLowerCase().indexOf(pre.toLowerCase()) < 0)
          t = (pre === pre.toUpperCase() ? pre.toLowerCase().replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : pre) + ' ' + rest;
        else t = rest;
      }
      t = t.split(/\s+[|\u2013-]\s+/)[0];
      return t.length > 40 ? t.slice(0, 38).replace(/\s+\S*$/, '') + '\u2026' : t;
    }
    // collections that are not useful as a "Shop by" shortcut
    var JUNK_COLLECTION = /black friday|deals|\bsale\b|from the game|wheelchair|boost|on demand|orderly|upsell|returns|^hide$/i;
    function usefulCollection(c, q) {
      if (JUNK_COLLECTION.test(c.title)) return false;
      var m = /^\s*brand\s*\|\s*(.+)$/i.exec(c.title);   // a brand only when the search names it
      if (m) return q.toLowerCase().indexOf(m[1].replace(/\s+(wheels|decks|trucks|bearings)$/i, '').toLowerCase().replace(/\.$/, '')) >= 0;
      return true;
    }
    function render(q, data, count, smart) {
      var r = (data && data.resources && data.resources.results) || {};
      var products = r.products || [], cols = (r.collections || []).filter(function (c) { return usefulCollection(c, q); }), pages = (r.pages || []).concat(r.articles || []);
      var queries = (r.queries || []).filter(function (x) { return norm(x.text) !== norm(q); }).slice(0, window.innerWidth < 1025 ? 3 : 5);
      var pokemon = pokemonHint(q);
      if (!products.length && !cols.length && !pages.length && !smart && !pokemon) {
        box.innerHTML = '<div class="np-empty"><strong>No matches for “' + esc(q) + '”</strong><span>Check the spelling, or try one of these:</span></div>' +
          '<div class="np-chips np-chips--pad">' + POPULAR.map(function (t) {
            return '<a class="np-chip" href="/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(t) + '">' + esc(t) + '</a>';
          }).join('') + '</div>';
        open(); return;
      }
      var side = '';
      if (pokemon) {
        side += '<a class="np-smart np-link" href="' + POKEMON_URL + '"><span class="np-smart__label"><b>Santa Cruz x Pokémon</b> decks</span>' +
          '<span class="np-smart__count">' + esc(pokemon) + ' →</span></a>';
      }
      if (smart) {
        side += '<a class="np-smart np-link" href="' + esc(smart.url) + '"><span class="np-smart__label">' +
          (smart.partial ? 'Closest match: ' : '') +
          (smart.what.length ? '<b>' + esc(smart.what.join(' \u00b7 ')) + '</b> ' : (smart.sort ? '' : 'All ')) +
          (smart.what.some(function (w) { var lw = String(w).toLowerCase(), last = smart.where.toLowerCase().split(' ').pop(); return lw.indexOf(last.replace(/s$/, '')) !== -1; }) ? '' : esc(smart.where)) +
          (smart.sort ? ', ' + esc(smart.sort) : '') +
          '</span><span class="np-smart__count">' + smart.count + ' in stock \u2192</span></a>';
      }
      if (queries.length) {
        side += '<div class="np-head">Suggestions</div><ul class="np-list">' + queries.map(function (x) {
          return '<li><a class="np-link" href="/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(x.text) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6" fill="none" stroke="currentColor" stroke-width="2"/><path d="M15 15l5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
            '<span>' + hlRest(x.text, q) + '</span></a></li>';
        }).join('') + '</ul>';
      }
      if (cols.length) {
        var seen = {};
        side += '<div class="np-head">Shop by</div><div class="np-chips">' + cols.filter(function (c) {
          if (!usefulCollection(c, q)) return false;
          var k = cleanCollection(c.title).toLowerCase(); if (seen[k]) return false; seen[k] = 1; return true;
        }).slice(0, 6).map(function (c) {
          return '<a class="np-chip np-link" href="' + esc(c.url) + '">' + hl(cleanCollection(c.title), q) + '</a>';
        }).join('') + '</div>';
      }
      if (pages.length) {
        side += '<div class="np-head">Help &amp; guides</div><ul class="np-list">' + pages.slice(0, 3).map(function (pg) {
          return '<li><a class="np-link" href="' + esc(pg.url) + '"><span>' + hl(pg.title, q) + '</span></a></li>';
        }).join('') + '</ul>';
      }
      var main = '';
      if (products.length) {
        main = '<div class="np-head">Products</div><ul class="np-grid">' + products.map(function (p) {
          var price = parseFloat(p.price), was = parseFloat(p.compare_at_price_max);
          var sale = was > price;
          var off = sale ? Math.round((1 - price / was) * 100) : 0;
          return '<li><a class="np-card np-link" href="' + esc(p.url) + '">' +
            '<span class="np-card__img">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '') +
            (off >= 5 ? '<span class="np-badge">-' + off + '%</span>' : '') + '</span>' +
            '<span class="np-card__vendor">' + esc(p.vendor) + '</span>' +
            '<span class="np-card__title">' + hl(p.title, q) + '</span>' +
            '<span class="np-card__price' + (sale ? ' is-sale' : '') + '">' + money(p.price) +
            (sale ? ' <s>' + money(p.compare_at_price_max) + '</s>' : '') + '</span></a></li>';
        }).join('') + '</ul>';
      }
      var all = '/search?type=product&options%5Bprefix%5D=last&nr=1&q=' + encodeURIComponent(q);
      box.innerHTML = '<div class="np-body' + (side ? '' : ' np-body--single') + '">' +
        (side ? '<div class="np-side">' + side + '</div>' : '') +
        '<div class="np-main">' + main + '</div></div>' +
        '<a class="np-all np-link" href="' + all + '"><span>See all ' + (count ? count + ' ' : '') + 'results for “' + esc(q) + '”</span><span aria-hidden="true">→</span></a>';
      open();
      active = -1;
    }
    function run() {
      var q = input.value.trim();
      if (q.length < 2) { last = ''; if (q.length) close(); return; }   // empty: the recent/popular panel stays
      if (q === last) { if (box.innerHTML) open(); return; }
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var opts = ctrl ? { signal: ctrl.signal } : {};
      // collections + pages from predictive search; products from the full search page's own
      // ranking (templates/search.native-json.liquid), which puts the real thing first
      var sUrl = '/search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=query,collection,page,article&resources[limit]=10';
      var pUrl = '/search?view=native-json&type=product&options%5Bprefix%5D=last&filter.v.availability=1&q=' + encodeURIComponent(q);
      Promise.all([
        fetch(sUrl, opts).then(function (r) { return r.json(); }).catch(function () { return {}; }),
        fetch(pUrl, opts).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }),
        understand(q).catch(function () { return null; })
      ]).then(function (res) {
        smartNow = res[2];
        var d = res[0] || {};
        d.resources = d.resources || {}; d.resources.results = d.resources.results || {};
        d.resources.results.products = (res[1] && res[1].products) || [];
        if (input.value.trim() === q) render(q, d, res[1] && res[1].results_count, res[2]);
      });
    }
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    if (input.value.trim().length >= 2 && document.activeElement === input) run();
    input.addEventListener('focus', function () { if (box.innerHTML && input.value.trim().length >= 2) open(); });
    var active = -1;
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (box.hidden || (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter')) return;
      var links = [].slice.call(box.querySelectorAll('.np-link'));
      if (!links.length) return;
      if (e.key === 'Enter') { if (active >= 0 && links[active]) { e.preventDefault(); window.location.href = links[active].href; } return; }
      e.preventDefault();
      active = e.key === 'ArrowDown' ? Math.min(active + 1, links.length - 1) : Math.max(active - 1, -1);
      links.forEach(function (l, k) { l.classList.toggle('is-active', k === active); });
      if (links[active] && links[active].closest('.np-list') && links[active].href.indexOf('/search?') !== -1) {
        var sq = new URL(links[active].href, location.href).searchParams.get('q');
        if (sq) { input.value = sq; last = sq; }
      }
      if (links[active]) links[active].scrollIntoView({ block: 'nearest' });
    });
    form.addEventListener('submit', function (e) {
      var q = input.value.trim();
      if (!q || !window.fetch || form.__brandChecked) return;
      e.preventDefault();
      rememberSearch(q);
      destination(q).then(function (url) {
        if (url) { window.location.href = url; return; }
        form.__brandChecked = true;
        form.submit();
      });
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) close(); });
    box.addEventListener('click', function (e) {
      var rm = e.target.closest && e.target.closest('[data-forget]');
      if (rm) { e.preventDefault(); e.stopPropagation(); forgetSearch(rm.getAttribute('data-forget')); focusPanel(); input.focus(); return; }
      if (input.value.trim().length >= 2) rememberSearch(input.value.trim());
    });

    /* clicking into an empty bar: recent searches + popular searches */
    function focusPanel() {
      var rec = recentList();
      var html = '';
      if (rec.length) {
        html += '<div class="np-head">Recent searches</div><ul class="np-list">' + rec.map(function (t) {
          return '<li class="np-recent"><a class="np-link" href="/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(t) + '">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 7v5l3 2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><circle cx="12" cy="12" r="8" fill="none" stroke="currentColor" stroke-width="2"/></svg>' +
            '<span>' + esc(t) + '</span></a><button type="button" class="np-forget" data-forget="' + esc(t) + '" aria-label="Remove ' + esc(t) + '">\u00d7</button></li>';
        }).join('') + '</ul>';
      }
      html += '<div class="np-head">Popular searches</div><div class="np-chips">' + POPULAR.map(function (t) {
        return '<a class="np-chip np-link" href="/search?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(t) + '">' + esc(t) + '</a>';
      }).join('') + '</div>';
      box.innerHTML = '<div class="np-focus">' + html + '</div>';
      last = '';
      open();
    }
    input.addEventListener('focus', function () { if (!input.value.trim()) focusPanel(); });
    input.addEventListener('input', function () { if (!input.value.trim()) focusPanel(); });

    /* clear button */
    var clr = form.querySelector('.native-hsearch__clear');
    function syncClear() { if (clr) clr.hidden = !input.value; }
    if (clr) {
      clr.addEventListener('click', function () { input.value = ''; syncClear(); input.focus(); focusPanel(); });
      input.addEventListener('input', syncClear); syncClear();
    }
  }

  var brandChecked = false;
  function brandFromSearchPage() {
    if (brandChecked || !/^\/search\/?$/.test(window.location.pathname)) return;
    brandChecked = true;
    var p = new URLSearchParams(window.location.search);
    var q = (p.get('q') || '').trim();
    var other = false;
    p.forEach(function (v, k) { if ((k.indexOf('filter.') === 0 && k !== 'filter.v.availability') || k === 'page' || k === 'nr' || k === 'sort_by') other = true; });
    if (!q || other) return;
    destination(q).then(function (url) { if (url) window.location.replace(url); });
  }

  /* phones: keep the search bar at the top of the screen once the header has scrolled away */
  function stickyMobileBar() {
    var bar = document.querySelector('.native-hsearch--mobile');
    if (!bar || bar.__sticky || !('IntersectionObserver' in window)) return;
    bar.__sticky = true;
    var spacer = document.createElement('div');
    spacer.className = 'native-hsearch-spacer';
    bar.parentNode.insertBefore(spacer, bar);
    var sentinel = document.createElement('div');
    spacer.parentNode.insertBefore(sentinel, spacer);
    new IntersectionObserver(function (entries) {
      var off = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      if (window.innerWidth > 1024) off = false;
      spacer.style.height = off ? bar.offsetHeight + 'px' : '';
      spacer.classList.toggle('is-on', off);
      bar.classList.toggle('is-fixed', off);
    }).observe(sentinel);
  }

  /* ---------- desktop search layout: logo on the left, search in the middle of the logo row ---------- */
  function applyLayout() {
    if (document.querySelector('.native-hsearch--desktop')) document.documentElement.classList.add('np-layout-centre');
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== '/' || e.metaKey || e.ctrlKey || e.altKey) return;
    var t = e.target, tag = t && t.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (t && t.isContentEditable)) return;
    var bars = [].filter.call(document.querySelectorAll('.native-hsearch input[name="q"]'), function (i) { return i.offsetParent !== null; });
    if (bars[0]) { e.preventDefault(); bars[0].focus(); }
  });

  function init() {
    applyLayout();
    stickyMobileBar();
    brandFromSearchPage();
    document.querySelectorAll('form[action="/search"] input[name="q"], form[action$="/search"] input[name="q"]').forEach(function (input) {
      if (input.closest('[data-native-facets]')) return;
      attach(input);
    });
  }
  // Start as soon as the page is parsed (people type before images finish loading), then again
  // on load: theme.js wires its older dropdown at jQuery-ready, and the second pass removes it.
  function retireOld() {
    if (!window.jQuery) return;
    document.querySelectorAll('.np-form input[name="q"]').forEach(function (i) { window.jQuery(i).off('keyup change'); });
    window.jQuery('.np-form .search-results').remove();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  if (document.readyState === 'complete') retireOld();
  else window.addEventListener('load', function () { init(); retireOld(); });
})();
